<template>
  <div class="w_notice">
    <div class="w_notice_title clear_fix">
      <ul class="ul tc b_f-color">
        <li>平台公告</li>
      </ul>
      <i class="after t_b-c"></i>
    </div>
    <div class="w_notice_content">
      <template v-if="!loading">
        <dl class="dl">
          <dt>{{notice.info.title}}</dt>
          <dd>{{date_time}}</dd>
        </dl>
        <div class="wnc_body">
          <p v-for="(item,index) in blocks" :key="index">{{item}}</p>
        </div>
      </template>
      <div v-else class="wnc_body">
        <p>正在加载内容...</p>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapActions, mapState} from 'vuex';

  export default {
    mounted() {
      this.load(this.$route.query.notice);
    },
    computed: {
      ...mapState({
        notice: state => state.notice
      }),
      date_time() {
        if (!this.notice.info.send_time) return '';
        const d = new Date(this.notice.info.send_time * 1000);

        const n = num => (num < 10 ? '0' + num : '' + num);

        return [
          [
            d.getFullYear(),
            d.getMonth() + 1,
            d.getDate()
          ].map(n).join('-'),
          [
            d.getHours(),
            d.getMinutes(),
            d.getSeconds()
          ].map(n).join(':')
        ].join(' ');
      },
      blocks() {
        return this.notice.info && this.notice.info.content ? this.notice.info.content.split('\n') : [];
      }
    },
    data() {
      return {
        loading: false,
        name: 'app_notice'
      };
    },
    methods: {
      ...mapActions({
        loadInfo: 'loadNoticeDetail'
      }),
      async load(id) {
        this.loading = true;
        await this.loadInfo(id);
        this.loading = false;
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .w_notice {
    margin-top: 6px;
    background: #ffffff;

    .w_notice_title {
      padding: 0 10px;
      position: relative;
      background: #fafafa;
      height: 50px;
      overflow hidden;

      .after {
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        right: 0;
        height: 1px;
      }

      .ul {
        position relative;
        z-index: 9;
        float: left;
        padding: 0 22px;
        height: 47px;
        line-height: 47px;
        font-size: 0px;
        background: #ffffff;
        border-left: solid 1px;
        border-right: solid 1px;
        border-top: solid 3px;

        li {
          display inline-block;
          font-size: 14px;
          vertical-align: top;
        }
      }
    }

    .w_notice_content {
      min-height: 500px;
      padding: 0 28px;

      .dl {
        padding-top: 42px;
        text-align: center;
        border-bottom: solid 1px #e6e6e6;

        dt {
          font-size: 18px;
          color: #000000;
        }

        dd {
          font-size: 12px;
          color: #666666;
          padding-top: 20px;
          padding-bottom: 28px;
        }
      }

      .wnc_body {
        padding: 15px 0;
        line-height: 36px;
        font-size: 14px;
        color: #333333;

        p {
          text-indent: 2em;
        }
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/notice/index.vue